import moment from 'moment';
import _ from 'lodash';

import { ExportTotalsEnum } from 'Common/Constants/Enumeration/ExportTotalsEnum';
import {
  DATE_FORMAT_FOR_UI,
  DATE_FORMAT_FOR_EXPORT,
} from 'Common/Constants/dateformat';
import { ExportTotalsFieldEnum } from 'Common/FieldEnum';

export const formatFileName = formValues => {
  const date = moment().format(DATE_FORMAT_FOR_EXPORT);
  const selectedSiteIds = formValues[ExportTotalsFieldEnum.SelectedSiteIds];
  const unitNumber = formValues[ExportTotalsFieldEnum.UnitNumber];
  if (selectedSiteIds.length === 1) {
    return `${selectedSiteIds[0]}_${date}.csv`;
  } else {
    return `${unitNumber}_${date}.csv`;
  }
};

export const getDefaultValues = data => {
  const defaultBreakfastItemId = _.get(
    _.first(data[ExportTotalsFieldEnum.BreakfastItems]),
    'Id',
    ''
  );
  const defaultLunchItemId = _.get(
    _.first(data[ExportTotalsFieldEnum.LunchItems]),
    'Id',
    ''
  );
  return {
    [ExportTotalsFieldEnum.ExportType]: ExportTotalsEnum.Chartwells,
    [ExportTotalsFieldEnum.SelectedSiteIds]: [],
    [ExportTotalsFieldEnum.FromDate]: moment().format(DATE_FORMAT_FOR_UI),
    [ExportTotalsFieldEnum.ToDate]: moment().format(DATE_FORMAT_FOR_UI),
    [ExportTotalsFieldEnum.BreakfastItemId]: defaultBreakfastItemId,
    [ExportTotalsFieldEnum.LunchItemId]: defaultLunchItemId,
  };
};



// WEBPACK FOOTER //
// ./src/pages/exporttotals/helpers/exporttotals.js